type VersionMismatchCallback = () => void;

const listeners = new Set<VersionMismatchCallback>();
let isActive = false;

export function emitVersionMismatch(): void {
  if (isActive) return;
  isActive = true;
  listeners.forEach((callback) => callback());
}

export function onVersionMismatch(callback: VersionMismatchCallback): void {
  listeners.add(callback);
  if (isActive) {
    callback();
  }
}

export function offVersionMismatch(callback: VersionMismatchCallback): void {
  listeners.delete(callback);
}

// Exported for testing only
export function resetVersionMismatch(): void {
  isActive = false;
  listeners.clear();
}
